import { buildRouteHead } from "@/lib/seo/routeHead";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/zh-cn/zh-cn/blog")({
  head: () => buildRouteHead("/zh-cn/zh-cn/blog", { noIndex: true }),
  beforeLoad: () => {
    throw redirect({ to: "/zh-cn/blog", replace: true });
  },
});
